import parsePhoneNumberFromString from 'libphonenumber-js';
import {
	STEPPER_EMPTY_PHONE_PLACEHOLDER,
	STEPPER_SETUP_STEPS
} from './constants';
import { StepperSetupStepKey, StepperSetupStepStatus } from './types';

export const getNextStepperSetupStepKey = (
	currentStepKey: StepperSetupStepKey
) => {
	const currentStepIndex = STEPPER_SETUP_STEPS.findIndex(
		(step) => step.key === currentStepKey
	);

	return (
		STEPPER_SETUP_STEPS[currentStepIndex + 1]?.key ??
		StepperSetupStepKey.ExtractWebsiteContent
	);
};

export const getStepperSetupStepStatus = (
	stepKey: StepperSetupStepKey,
	activeStepKey: StepperSetupStepKey,
	isSetupComplete: boolean
) => {
	if (isSetupComplete) {
		return StepperSetupStepStatus.Completed;
	}

	if (stepKey === activeStepKey) {
		return StepperSetupStepStatus.Active;
	}

	const stepIndex = STEPPER_SETUP_STEPS.findIndex(
		(step) => step.key === stepKey
	);
	const activeStepIndex = STEPPER_SETUP_STEPS.findIndex(
		(step) => step.key === activeStepKey
	);

	if (stepIndex < activeStepIndex) {
		return StepperSetupStepStatus.Completed;
	}

	return StepperSetupStepStatus.Upcoming;
};

export const formatStepperPhoneNumber = (phoneNumber: string) => {
	const trimmedPhoneNumber = phoneNumber.trim();

	if (!trimmedPhoneNumber) {
		return '';
	}

	const normalizedPhoneNumber = trimmedPhoneNumber.startsWith('+')
		? trimmedPhoneNumber
		: `+${trimmedPhoneNumber}`;
	const parsedPhoneNumber = parsePhoneNumberFromString(normalizedPhoneNumber);

	return parsedPhoneNumber?.formatInternational() ?? trimmedPhoneNumber;
};

export const formatStepperDisplayPhoneNumber = (phoneNumber: string) =>
	formatStepperPhoneNumber(phoneNumber) || STEPPER_EMPTY_PHONE_PLACEHOLDER;

export const getStepperPhoneUri = (phoneNumber: string) => {
	const trimmedPhoneNumber = phoneNumber.trim();

	if (!trimmedPhoneNumber) {
		return '';
	}

	const normalizedPhoneNumber = trimmedPhoneNumber.startsWith('+')
		? trimmedPhoneNumber
		: `+${trimmedPhoneNumber}`;
	const parsedPhoneNumber = parsePhoneNumberFromString(normalizedPhoneNumber);

	return parsedPhoneNumber?.getURI() ?? `tel:${normalizedPhoneNumber}`;
};
